import Vue from 'vue'
import VueRouter from 'vue-router'
import PageNotFound from '../views/PageNotFoundView.vue'
import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import CustomersView from '../views/CustomersView.vue'
import ManuimView from '../views/ManuimView.vue'
import UsersView from '../views/UsersView.vue'
import CreateManuiView from '../views/seller/CreateManuiView.vue'
import AllManuimView from '../views/AllManuimView.vue'
import PlansView from '../views/admin/PlansView.vue'
import CommunitiesView from '../views/admin/CommunitiesView.vue'
import TicketsListView from '../views/tickets/TicketsListView.vue'
import TicketView from '../views/tickets/TicketView.vue'
import LogsView from '../views/admin/LogsView.vue'
import RessetPassView from '../views/ResetPasswordView.vue'
import SimsView from '../views/SimsView.vue'
import ReportsView from '../views/ReportsView.vue'
import ServiceRequestsView from '../views/admin/ServiceRequestsView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/customers',
    name: 'customers',
    component: CustomersView,
  },
  {
    path: '/manuim/:id/:name/:cardId',
    name: 'manuim',
    component: ManuimView,
  },
  {
    path: '/all-manuim',
    name: 'allManuim',
    component: AllManuimView,
  },
  {
    path: '/users',
    name: 'users',
    component: UsersView,
  },
  {
    path: '/plans',
    name: 'plans',
    component: PlansView,
  },
  {
    path: '/communities',
    name: 'communities',
    component: CommunitiesView,
  },
  {
    path: '/sims',
    name: 'sims',
    component: SimsView,
  },
  {
    path: '/reports',
    name: 'reports',
    component: ReportsView,
  },
  {
    path: '/create-manui',
    name: 'createManui',
    component: CreateManuiView,
  },
  // {
  //   path: '/tickets',
  //   name: 'tickets',
  //   component: TicketsListView,
  // },
  {
    path: '/service-requests',
    name: 'ServiceRequests',
    component: ServiceRequestsView,
  },
  {
    path: '/ticket/:id',
    name: 'TicketDetails',
    component: TicketView,
  },
  {
    path: '/logs',
    name: 'logs',
    component: LogsView,
  },
  {
    path: '/resset-password/:token',
    name: 'ressetPass',
    component: RessetPassView,
  },

  { path: '*', component: PageNotFound }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
